import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './views/components/Navbar';
import AboutView from './views/AboutView';
import ExperienceView from './views/ExperienceView';
import ProjectsView from './views/ProjectsView';
import ProjectDetailView from "./views/ProjectDetailView";  // Added route for project detail view
import ContactView from './views/ContactView';
import Footer from './views/components/Footer';
import { ErrorBoundary } from './views/components/ErrorBoundary';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Navbar />
        <div style={{ paddingTop: '4.5rem' }}>
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<Navigate to="/about" />} />
              <Route path="/about" element={<AboutView />} />
              <Route path="/experience" element={<ExperienceView />} />
              <Route path="/projects" element={<ProjectsView />} />
              <Route path="/projects/:id" element={<ProjectDetailView />} />  {/* Added route for project detail view */}
              <Route path="/contact" element={<ContactView />} />
            </Routes>
          </ErrorBoundary>
        </div>
        <Footer/>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
